import { api } from "./api";
import { ListRequest, MessageResponse } from "../types/common/commonTypes";

import {
  ShipmentRecordCreate,
  ShipmentRecordUpdate,
  ShipmentRecordFull,
  PaginatedShipmentRecordResponse,
} from "../types/shipmentsTypes";

/**
 * Inventory Management Service
 *
 * Provides complete integration with all 12 inventory management API endpoints:
 * - Core lot management (CRUD operations)
 * - FIFO allocation engine
 * - Real-time availability tracking
 * - Lot shipping and movement
 * - Comprehensive inventory summaries
 *
 * Auto-generation: Lot numbers are auto-generated by backend (YY-###### format)
 * Example: 24-000001, 24-000002, etc. (resets annually)
 */
const ship_base = "/shipments";
export const shipmentService = {
  // ========================================
  // Core Inventory Lot Management (6 endpoints)
  // ========================================

  /**
   * Create a new inventory lot
   * POST /api/v1/inventory/lots
   * Note: Lot numbers are auto-generated by backend (format: YY-######)
   */
  create: async (data: ShipmentRecordCreate): Promise<ShipmentRecordFull> => {
    const response = await api.post(`${ship_base}/`, data);
    return response.data;
  },
  list: async (
    params: ListRequest,
  ): Promise<PaginatedShipmentRecordResponse> => {
    const response = await api.post(`${ship_base}/search`, params);
    return response.data;
  },

  /**
   * Get a specific inventory lot by ID
   * GET /api/v1/inventory/lots/{lot_id}
   */
  getById: async (id: string): Promise<ShipmentRecordFull> => {
    const response = await api.get(`${ship_base}/${id}`);
    return response.data;
  },

  /**
   * Update an inventory lot
   * PUT /api/v1/inventory/lots/{lot_id}
   */
  update: async (
    id: string,
    data: ShipmentRecordUpdate,
  ): Promise<MessageResponse> => {
    data.id = id;
    const response = await api.patch(`${ship_base}/${id}`, data);
    return response.data;
  },
};
